export default "__VITE_ASSET__ByliJmYQ__ 480w, __VITE_ASSET__BOF9WqSh__ 768w, __VITE_ASSET__W$OXeW$K__ 1200w, __VITE_ASSET__DB9RyjFZ__ 1824w";